/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

/*
 * Copyright (c) 2026. Orion Analytics.
 * All Rights Reserved.
 */

import Plot from "react-plotly.js";

export default function ClientSnapshotChart({

    latestData = []

}) {

    if (!latestData.length) {

        return (

            <div
                className="
                    bg-slate-950
                    border
                    border-slate-800
                    rounded-3xl
                    p-6
                    text-slate-400
                "
            >
                No client positioning data available.
            </div>

        );

    }

    const sortedData = [...latestData]

        .sort(

            (a, b) =>

                (
                    b.total_long_oi +
                    b.total_short_oi
                ) -

                (
                    a.total_long_oi +
                    a.total_short_oi
                )

        );

    const clients = sortedData.map(
        d => d.client
    );

    const longOI = sortedData.map(
        d => d.total_long_oi
    );

    const shortOI = sortedData.map(
        d => d.total_short_oi
    );

    return (

        <div
            className="
                bg-slate-950
                border
                border-slate-800
                rounded-3xl
                p-4
            "
        >

            {/* HEADER */}

            <div
                className="
                    mb-4
                "
            >

                <h2
                    className="
                        text-xl
                        font-semibold
                        text-white
                    "
                >
                    Client Long vs Short Positioning
                </h2>

                <p
                    className="
                        text-sm
                        text-slate-400
                    "
                >
                    Current futures open interest by participant category
                </p>

            </div>

            {/* CHART */}

            <Plot

                data={[

                    {

                        x: clients,

                        y: longOI,

                        type: "bar",

                        name: "Long OI",

                        marker: {
                            color:
                                "#10b981"
                        }

                    },

                    {

                        x: clients,

                        y: shortOI,

                        type: "bar",

                        name: "Short OI",

                        marker: {
                            color:
                                "#ef4444"
                        }

                    }

                ]}

                layout={{

                    height: 500,

                    barmode: "group",

                    paper_bgcolor:
                        "#020617",

                    plot_bgcolor:
                        "#020617",

                    font: {
                        color:
                            "#cbd5e1"
                    },

                    margin: {
                        l: 70,
                        r: 30,
                        t: 20,
                        b: 80
                    },

                    xaxis: {

                        tickangle: -25,

                        showgrid: false

                    },

                    yaxis: {

                        title:
                            "Open Interest",

                        gridcolor:
                            "#1e293b"

                    },

                    legend: {

                        orientation: "h",

                        x: 0,

                        y: 1.12

                    }

                }}

                config={{

                    responsive: true,

                    displayModeBar: false

                }}

                style={{
                    width: "100%"
                }}

            />

            {/* FOOTER */}

            <div
                className="
                    mt-3
                    text-xs
                    text-slate-500
                "
            >
                Compare long and short exposure across FIIs,
                DIIs, Proprietary Traders and Clients.
            </div>

        </div>

    );

}